import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as myGlobals from '../../app.component';

@Injectable({
  providedIn: 'root',
})
export class StudentServiceService {
  private baseUrl = myGlobals.baseUrl;

  constructor(private http: HttpClient) {}
  getBasicDetails() {
    return this.http.get(`${this.baseUrl}/getBasicDetails`);
  }

  addStudentBasic(token, data) {
    return this.http.post(
      `${this.baseUrl}/addStudentBasic?token=` + token,
      data
    );
  }
  updateBasic(data) {
    return this.http.post(`${this.baseUrl}/updateStudentBasic`, data);
  }

  addAddress(data) {
    return this.http.post(`${this.baseUrl}/addinstaddress`, data);
  }

  getInstituteDetails() {
    return this.http.get(`${this.baseUrl}/getStudentInstituteDetails`);
  }
  getState() {
    return this.http.get(`${this.baseUrl}/getState`);
  }
  getDistrict(data) {
    return this.http.get(`${this.baseUrl}/getDistrict?state_id=` + data);
  }
  getBasicEducation() {
    return this.http.get(`${this.baseUrl}/getBasicEducation`);
  }

  addBasicEducation(data) {
    return this.http.post(`${this.baseUrl}/addBasicEducation`, data);
  }

  addHighEducation(data) {
    return this.http.post(`${this.baseUrl}/addHighEducation`, data);
  }

  getHighEducation() {
    return this.http.get(`${this.baseUrl}/getHighEducation`);
  }

  getStudentUserDetails() {
    return this.http.get(`${this.baseUrl}/getStudentUserDetails`);
  }

  DetailsSubmit(data) {
    return this.http.post(`${this.baseUrl}/DetailsSubmit`, data);
  }

  isDetailsSubmitted() {
    return this.http.get(`${this.baseUrl}/isDetailsSubmitted`);
  }

  isPreview() {
    return this.http.get(`${this.baseUrl}/isPreview`);
  }

  getStream() {
    return this.http.get(`${this.baseUrl}/getStreamsForAssessment`);
  }

  getLevel(data) {
    return this.http.post(`${this.baseUrl}/getLevelsForStreams`, data);
  }

  fetchDepartments(stream_id) {
    return this.http.get(
      `${this.baseUrl}/fetchDepartments?stream_id=` + stream_id
    );
  }
  getHodByDepartment(pid, department, course){
    return this.http.get(`${this.baseUrl}/getHodByDepartment?pid=${pid}&department=${department}&course=${course}`);
  }

  getDepartment() {
    return this.http.get(`${this.baseUrl}/getDepartmentStudent`);
  }
  getStreamByDept(department){
    return this.http.get(`${this.baseUrl}/getStreamByDept?department=${department}`);
  }
  getCourseByLevelDepartment(programme, level, department){
    return this.http.get(`${this.baseUrl}/getCourseByLevelDepartmentPid?programme=${programme}&level=${level}&department=${department}`);
  }

  getStudentLevel() {
    return this.http.get(
      `${this.baseUrl}/getStudentLevel`
    );
  }
  getLocation(){
    return this.http.get(`${this.baseUrl}/getLocations`);
  }
  getHobbies(){
    return this.http.get(`${this.baseUrl}/getHobbies`);
  }
  studentPersonalDetails(data){
    return this.http.post(`${this.baseUrl}/studentPersonalDetails`,data);
  }
  getPersonalDetails(){
    return this.http.get(`${this.baseUrl}/getStudentPersonalDetails`);
  }
  studentApplicationPrint(){
    return this.http.get(`${this.baseUrl}/studentApplicationPrint`);
  }
  studentPreviewUpdate(data){
    return this.http.post(`${this.baseUrl}/studentPreviewUpdate`,data);
  }
  getSmokingHabbits(){
    return this.http.get(`${this.baseUrl}/getsmokinghabbit`);
  }
  getFamilyValue(){
    return this.http.get(`${this.baseUrl}/getfamilyvalue`);
  }
  getStayingStatus(){
    return this.http.get(`${this.baseUrl}/getstudentstayingstatus`);
  }
  getCareerFactor(){
    return this.http.get(`${this.baseUrl}/getCareerFactors`);
  }
  getEatingPreferences(){
    return this.http.get(`${this.baseUrl}/getEatingPreferences`);
  }
  getPersonalityTrait(){
    return this.http.get(`${this.baseUrl}/getPersonalityTrait`);
  }
  getRelations(){
    return this.http.get(`${this.baseUrl}/getRelations`);
  }
  getFutureReferences(type){
    return this.http.get(`${this.baseUrl}/getFutureReferences?type=${type}`);
  }
  getStressBuster(){
    return this.http.get(`${this.baseUrl}/getStressBuster`);
  }
  getReasonForChoosingDiscipline(){
    return this.http.get(`${this.baseUrl}/getReasonForChoosingDiscipline`);
  }
  getHealthMaintainsOption(){
    return this.http.get(`${this.baseUrl}/getHealthMaintainsOption`);
  }
  getProgrammingLanguages(){
    return this.http.get(`${this.baseUrl}/getProgrammingLanguages`);
  }
  getFevMentor(){
    return this.http.get(`${this.baseUrl}/getFevMentor`);
  }
  getFevSubjects(){
    return this.http.get(`${this.baseUrl}/getFevSubjects`);
  }
}
